/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainStoreEnumsSupportedWebPublishingPlatform } from './FxIdDomainStoreEnumsSupportedWebPublishingPlatform';
import {
    FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSON,
    FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSONTyped,
    FxIdDomainStoreEnumsSupportedWebPublishingPlatformToJSON,
    FxIdDomainStoreEnumsSupportedWebPublishingPlatformToJSONTyped,
} from './FxIdDomainStoreEnumsSupportedWebPublishingPlatform';

/**
 * 
 * @export
 * @interface FxIdWebFeaturesStoreStoreDataRequest
 */
export interface FxIdWebFeaturesStoreStoreDataRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreStoreDataRequest
     */
    Game: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FxIdWebFeaturesStoreStoreDataRequest
     */
    ProductsSku?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreStoreDataRequest
     */
    Locale?: string | null;
    /**
     * 
     * @type {FxIdDomainStoreEnumsSupportedWebPublishingPlatform}
     * @memberof FxIdWebFeaturesStoreStoreDataRequest
     */
    WebPublishingPlatform: FxIdDomainStoreEnumsSupportedWebPublishingPlatform;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreStoreDataRequest
     */
    Currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreStoreDataRequest
     */
    Country?: string | null;
    /**
     * 
     * @type {any}
     * @memberof FxIdWebFeaturesStoreStoreDataRequest
     */
    StoreAdditionalData?: any | null;
}



/**
 * Check if a given object implements the FxIdWebFeaturesStoreStoreDataRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreStoreDataRequest(value: object): value is FxIdWebFeaturesStoreStoreDataRequest {
    if (!('Game' in value) || value['Game'] === undefined) return false;
    if (!('WebPublishingPlatform' in value) || value['WebPublishingPlatform'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesStoreStoreDataRequestFromJSON(json: any): FxIdWebFeaturesStoreStoreDataRequest {
    return FxIdWebFeaturesStoreStoreDataRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreStoreDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreStoreDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Game': json['Game'],
        'ProductsSku': json['ProductsSku'] == null ? undefined : json['ProductsSku'],
        'Locale': json['Locale'] == null ? undefined : json['Locale'],
        'WebPublishingPlatform': FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSON(json['WebPublishingPlatform']),
        'Currency': json['Currency'] == null ? undefined : json['Currency'],
        'Country': json['Country'] == null ? undefined : json['Country'],
        'StoreAdditionalData': json['StoreAdditionalData'] == null ? undefined : json['StoreAdditionalData'],
    };
}

export function FxIdWebFeaturesStoreStoreDataRequestToJSON(json: any): FxIdWebFeaturesStoreStoreDataRequest {
    return FxIdWebFeaturesStoreStoreDataRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreStoreDataRequestToJSONTyped(value?: FxIdWebFeaturesStoreStoreDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Game': value['Game'],
        'ProductsSku': value['ProductsSku'],
        'Locale': value['Locale'],
        'WebPublishingPlatform': FxIdDomainStoreEnumsSupportedWebPublishingPlatformToJSON(value['WebPublishingPlatform']),
        'Currency': value['Currency'],
        'Country': value['Country'],
        'StoreAdditionalData': value['StoreAdditionalData'],
    };
}

